/**
 * Read a class name out of a complete, literal-keyed record.
 *
 * `styles[someUnionValue]` is a `security/detect-object-injection` sink, and by
 * Phase 140 the same colour-to-class lookup appears in seven components. This
 * puts the one unavoidable suppression in a single place instead of scattering
 * it, and the signature is what makes it safe: `K` is a literal union and `map`
 * must be a complete record over it, so no caller can pass a key that reaches
 * `Object.prototype`.
 */
export function classFor<K extends string>(map: Readonly<Record<K, string>>, key: K): string {
  // eslint-disable-next-line security/detect-object-injection -- see the note above: K is a literal union and `map` is a complete own-key record over it
  return map[key] ?? '';
}
